import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export interface CommissionInvoice {
  number: string;
  url: string;
}

const getConversationCommissionInvoice =
  (makeCall: MakeCall) => (userId: number, conversationId: number) =>
    makeCall<CommissionInvoice>(
      'GET',
      `/v1/user/${userId}/conversation/${conversationId}/commission-invoice`,
    );

export default getConversationCommissionInvoice;
